export default __webpack_public_path__ + "static/media/Icon=Practice Locations.31802921.svg";